import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTaskActions } from '../context/TaskContext';

export const useTaskFromUrl = () => {
  const location = useLocation();
  const { openViewTask } = useTaskActions();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const taskId = searchParams.get('id');

    if (taskId) {
      // Open the task with minimal data - ViewTaskRefactored will fetch full details
      openViewTask({
        task_id: taskId,
        pk: `task#${taskId}`, // Add pk format for consistency
      });
    }
  }, [location.search]); // Only re-run when search params change
};
